
import { Vue, Component, Prop } from 'vue-property-decorator'
import FlexGroup from '@/components/layout/FlexGroup.vue'
import LazyImage from '@/components/ui/LazyImage.vue'

@Component({
  components: {
    LazyImage,
    FlexGroup
  }
})
export default class Card extends Vue {
  @Prop({ default: null })
  private readonly image!: string;

  @Prop({ default: '' })
  private readonly altText!: string;

  @Prop({ default: '0.75' })
  private readonly imageAr!: string;

  @Prop()
  private readonly href!: string;

  @Prop()
  private readonly isExternal!: boolean;

  handleClicked (): void {
    if (this.isExternal) {
      window.open(this.href, '_blank')
    } else {
      this.$router.push(this.href)
    }
  }
}
